import { GET_SKIDS_FOR_RECEIVING_INVOICE } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_SKIDS_FOR_RECEIVING_INVOICE:
            return action.payload;
        default:
            return state;
    }
}